import React ,{useState, useEffect, useContext}from 'react';
import {AuthContext} from "../../../config/AuthContext";
import {Button, Col, Form, Input, Modal, Row, Select, InputNumber } from 'antd';
import Colors from "../../../styles/Colors";
import {BiCheck, BiX} from "react-icons/bi";
import toast, {Toaster} from 'react-hot-toast';
import LlocTreball from "../../../model/root/LlocTreball";
import {GetEmpresas} from '../../../dao/admin/GetEmpresas';
import {PostLlocTreball} from "../../../dao/root/PostLlocTreball";


const { Option } = Select;

interface Props {
    element: LlocTreball;
    visible: boolean;
    onClose: (value: boolean) => void;
    update: boolean;
}

const LlocDeTreballAdminModal: React.FC<Props> = ({element, visible, onClose, update }) => {

    const [form] = Form.useForm();
    const [empresas, setDadesEmpresa] = useState<any[]>([]);
    const {isLoggedIn, userId, user, page} = useContext(AuthContext);

    useEffect(() => {
           if (visible) {
                checkDades();
            }
    }, [visible]);

    async function checkDades() {
        // Obtener empresas
        try {
            const dadesEmpresas = await GetEmpresas(1, page); // TO-DO: Cambiar por id_parent
            setDadesEmpresa(dadesEmpresas || []);
        } catch (error) {
            console.error("Error:", error);
            setDadesEmpresa([])
        }
    }

    const handleSubmit = () => {
        const formData = form.getFieldsValue();


        if (formData.entrada !== null && formData.sortida !== null) {
            const llocTreball = new LlocTreball(formData.id, formData.id, formData.nom, formData.latitud,
                formData.longitud);
            const empresaSeleccionada = form.getFieldValue('empresa');
            PostLlocTreball(llocTreball, empresaSeleccionada);

            onClose(true);
        } else {
            toast('Falten dades.');
        }

    };

    const filterOption = (input: string, option?: { label: string; value: string }) =>
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase());

    const handleCancel = () => {
        onClose(false);
    };

    return (
        <>
            <Toaster/>
            <Modal
                title="Crear/Editar Lloc de treball"
                open={visible}
                onCancel={handleCancel}
                footer={[
                    
                ]}
                width={"40%"}
            >
                <Form form={form} initialValues={element} onFinish={handleSubmit}>
                       <Form.Item 
                        label="Empresa" 
                        name="empresa" 
                        rules={[{ required: true, message: 'Introdueix l\'empresa' }]}
                    >
                        <Select
                            disabled={update}
                            placeholder="Selecciona una empresa"
                        >
                            {Array.isArray(empresas) && empresas.map(value =>
                                <Option key={value.id} value={value.datasource}>
                                    {value.nomEmpresa}
                                </Option>
                            )}
                        </Select>
                    </Form.Item>
                    <Row gutter={[16, 16]}>
                        <Col span={4}>
                            <Form.Item label="ID" name="id">
                                <Input disabled/>
                            </Form.Item>
                        </Col>
                        <Col flex="auto">
                            <Form.Item label="Nom" name="nom" 
                                rules={[{ required: true, message: 'Aquest element és obligatori' }]}>
                                <Input type={"text"}/>
                            </Form.Item>

                        </Col>
                    </Row>
                    <Row gutter={[16, 16]}>
                        <Col span={12}>
                            <Form.Item label="Longitud" name="longitud"
                                rules={[{ required: true, message: 'Aquest element és obligatori' }]}>
                                <InputNumber step={0.01} style={{ width: 200 }}/>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="Latitud" name="latitud" 
                                    rules={[{ required: true, message: 'Aquest element és obligatori' }]}>
                                <InputNumber step={0.01} style={{ width: 200 }}/>
                            </Form.Item>
                        </Col>
                        
                    </Row>        
                        
                     <hr/>
                    <Row gutter={[16, 16]}>
                        <Col span={1}>
                            <Form.Item wrapperCol={{offset: 0, span: 16}}>
                                <Button title={"Aceptar"} htmlType={"submit"}
                                        style={{backgroundColor: Colors.colors.color6}}><BiCheck/></Button>
                            </Form.Item>
                        </Col>
                        <Col span={1}>
                        </Col>
                        <Col span={1}>
                            <Button title={"Cancelar"} style={{backgroundColor: Colors.colors.color1}}
                                    onClick={handleCancel}><BiX/></Button>
                        </Col>
                    </Row>
                </Form>
            </Modal>
        </>
    );
};

export default LlocDeTreballAdminModal;
